export default __webpack_public_path__ + "static/media/print.37c14e55.svg";